const _ = (data: any) => {
  const arrayOfProducts = Object.entries(data).map(product => product[1]);
  return arrayOfProducts.map((product: any) => {
    return {
      name: product.productNumber,
      id: product.productNumber,
      price: product.unitPrice,
      brand: product.manufacturerCode,
      quantity: product.quantity,
      dimension5: product.amountInStock ? 'In Stock' : 'Out of Stock'
    };
  });
};

export default (data: any, event: string) => {
  const dataLayerObject = _(data.products);
  return {
    event,
    ...(data.shippingMethod && {
      additionalCriteria: data.shippingMethod.motdescription
    }),
    ecommerce: {
      checkout: {
        actionField: { step: data.step, option: data.option },
        products: [...dataLayerObject]
      }
    }
  };
};
